var map = {
	"./WYNx Brand ambassodor.jpg": 7128,
	"./education.jpg": 3688,
	"./gallery6.jpg": 2956,
	"./galleryn.jpg": 5396,
	"./galleryn0.jpg": 6790,
	"./galleryn1.jpg": 7843,
	"./galleryn10.png": 4467,
	"./galleryn11.jpg": 6654,
	"./galleryn12.jpg": 9737,
	"./galleryn13.jpg": 1692,
	"./galleryn2.jpg": 6036,
	"./galleryn3.jpg": 4561,
	"./galleryn4.jpg": 1650,
	"./galleryn5.jpg": 7999,
	"./galleryn6.jpg": 6688,
	"./galleryn7.png": 6973,
	"./galleryn8.jpg": 5134,
	"./galleryn9.jpg": 1595,
	"./galleryna5.png": 7262,
	"./gust.jpeg": 2270,
	"./gust0.jpeg": 4154,
	"./gust0.png": 8821,
	"./gust1.jpeg": 7905,
	"./gust10.png": 470,
	"./gust11.png": 5567,
	"./gust12.JPG": 3535,
	"./gust13.png": 4237,
	"./gust2.jpeg": 240,
	"./gust3.jpeg": 1063,
	"./gust4.jpeg": 7294,
	"./gust5.jpeg": 8053,
	"./gust6.png": 7155,
	"./gust7.png": 1946,
	"./gust8.png": 8541,
	"./gust9.jpg": 1907,
	"./sepgallery0.jpg": 9964,
	"./sepgallery1.jpg": 5225,
	"./sepgallery11.jpg": 6248,
	"./sepgallery12.jpg": 8823,
	"./sepgallery13.jpg": 9818,
	"./sepgallery14.jpg": 8761,
	"./sepgallery2.jpg": 5630,
	"./sepgallery3.jpg": 6939,
	"./sepgallery4.jpg": 9000,
	"./wyncbg.jpg": 6276,
	"./wynxbg.png": 9799,
	"./wynxbgn.jpg": 8065,
	"./wynxfooter.jpg": 1691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8206;